import { render, staticRenderFns } from "./UssdCode.vue?vue&type=template&id=31ae4ea2&scoped=true&"
import script from "./UssdCode.vue?vue&type=script&lang=js&"
export * from "./UssdCode.vue?vue&type=script&lang=js&"
import style0 from "./UssdCode.vue?vue&type=style&index=0&id=31ae4ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae4ea2",
  null
  
)

export default component.exports